import React from "react";
import * as c from "./exploreMangomint.module.scss";
import { ExploreBusiness, ExploreFeature } from "@components/shared/exploreMangomint";
import classNames from "classnames";

const ExploreMangomint = ({ className, businessTypes, features }) => {
  const renderSection = (heading, Component, props) => (
    <div className={c.wrapper}>
      <h4 className={classNames("h4", c.heading)} dangerouslySetInnerHTML={{ __html: heading }} />
      <Component {...props} />
    </div>
  );

  return (
    <section className={classNames(c.container, className)}>
      {businessTypes && renderSection(businessTypes.heading, ExploreBusiness, { businessTypes })}
      {features && renderSection(features.heading, ExploreFeature, { features })}
    </section>
  );
};

export default ExploreMangomint;
